module.exports = __webpack_public_path__ + "assets/248e0d6da4f06542b795f633eba51935.png";